import { render, staticRenderFns } from "./YkCampDistributionAccountIVRCalls.vue?vue&type=template&id=53041644&"
import script from "./YkCampDistributionAccountIVRCalls.vue?vue&type=script&lang=js&"
export * from "./YkCampDistributionAccountIVRCalls.vue?vue&type=script&lang=js&"
import style0 from "./YkCampDistributionAccountIVRCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports